<!-- src/app/app.component.html -->
<app-loading-overlay></app-loading-overlay>
<router-outlet></router-outlet>
<app-alert></app-alert>
